import Config from "@/config";

export const LEVEL_WIDTH = 6;   // should be same as on BG;
export const MAX_LEVEL = Config.TASKS_MAX_LEVEL;   // should be same as on BG;

export const splitPos = (pos) => {
    const result = [];
    for (let i = 0; i < pos.length; i += LEVEL_WIDTH) {
        result.push(pos.substring(i, i + LEVEL_WIDTH));
    }
    return result;
}

export const posPad = (pos) => {
    if (typeof pos == "number") pos = "" + pos;
    if (!pos) return pos;
    while (pos.length % LEVEL_WIDTH !== 0) {
        pos = "0" + pos;
    }
    return pos;
}

export const posLevel = (pos) => {
    if (!pos) return 0;
    pos = posPad(pos);
    if (pos.length < LEVEL_WIDTH) return 0;
    return pos.length / LEVEL_WIDTH - 1;
}

export const posParent = (pos) => {
    return pos.substring(0, posLevel(pos) * LEVEL_WIDTH);
}

export const posAreSiblings = (pos1, pos2) => {
    return posParent(pos1) === posParent(pos2);
}

export const posValue = (pos, level = undefined) => {
    pos = posPad(pos);
    if (typeof level == "undefined") return parseInt(pos.slice(-LEVEL_WIDTH));
    const l = posLevel(pos);
    if (level > l) level = l;
    return parseInt(pos.substring(level * LEVEL_WIDTH, (level + 1) * LEVEL_WIDTH));
}

export const posCanHaveChildren = (pos) => {
    return posLevel(pos) < MAX_LEVEL;
}
